// extracted by mini-css-extract-plugin
export default {"dateRange":"DateRange_dateRange__UbUNs","dateText":"DateRange_dateText__BapPA"};